import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { isOperator } from '../../services/AccountService'
import AddCommentBlock from './AddCommentBlock'
import RequestCommentsBlock from './RequestCommentsBlock'
import RequestCommentsStore from './stores/RequestCommentsStore'

const CommentsBlock = ({ store, updateComment }) => {
  const { data } = store
  const {
    id,
    status,
    isTakenByMe,
    hasDuplicates,
    reportId,
    reportStatus,
    financialSourceId,
    dealer,
    dataCheckingStatus,
    additionalInfo,
    address,
    addressType,
    apartment,
    author,
    authorId,
    authorName,
    building,
    categories,
    created,
    district,
    equipmentId,
    house,
    images,
    installationDate,
    isTaken,
    locality,
    name,
    patronymic,
    phone,
    preferentialCategory,
    priority,
    reason,
    reasonId,
    receiverId,
    sender,
    source,
    surname,
    territory,
  } = data

  const [commentsStore, setCommentsStore] = useState({})
  const getComments = (id) => {
    if (id) {
      const commentsStore = new RequestCommentsStore({ id })
      setCommentsStore(() => commentsStore)
      commentsStore.load()
    }
  }

  useEffect(() => {
    getComments(id)
  }, [
    id,
    status,
    isTakenByMe,
    reportId,
    reportStatus,
    financialSourceId,
    dealer,
    dataCheckingStatus,
    additionalInfo,
    address,
    addressType,
    apartment,
    author,
    authorId,
    authorName,
    building,
    categories,
    created,
    district,
    equipmentId,
    house,
    images,
    installationDate,
    isTaken,
    locality,
    name,
    patronymic,
    phone,
    preferentialCategory,
    priority,
    reason,
    reasonId,
    receiverId,
    sender,
    source,
    surname,
    territory,
    updateComment,
  ])

  return (
    <>
      <RequestCommentsBlock
        store={commentsStore}
        defaultOpenState={!isOperator()}
      />
      <AddCommentBlock store={store} getComments={getComments} id={id} />
    </>
  )
}

export default observer(CommentsBlock)
